import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import PdpSharedDetailAttributeLink from './helpers/PdpSharedDetailAttributeLink';

// helpers
import get from 'lodash.get';

function PdpSharedDetailMedium({ item }) {
    return (
        <PdpSharedDetailAttributeLink
            item={item}
            dataTn="pdp-spec-medium"
            attributes={get(item, 'attributes.material')}
        />
    );
}

PdpSharedDetailMedium.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailMedium, {
    item: graphql`
        fragment PdpSharedDetailMedium_item on Item {
            ...PdpSharedDetailAttributeLink_item
            attributes {
                material {
                    ...PdpSharedDetailAttributeLink_attributes
                }
            }
        }
    `,
});
